import React, { useState } from "react";
import { fmt } from "../../utils/presupuestoCalc";

// Editor generico de arrays (unidades / amenities / empleados) para el formulario de presupuesto.
// Port directo del componente ListEditor del HTML standalone (Presupuesto Habitia.standalone.html).
//
// Props:
//   items:    Array<Item>                — items existentes
//   fields:   Array<{ key, type, placeholder }>  — type: "text" | "num"
//   onChange: (nextItems) => void

export default function ListEditor({ items, fields, onChange }) {
  const [draft, setDraft] = useState(() =>
    fields.reduce((o, f) => ((o[f.key] = ""), o), {})
  );

  const add = () => {
    if (!draft[fields[0].key]) return;
    const item = { id: "x" + Date.now() };
    fields.forEach((f) => {
      item[f.key] =
        f.type === "num" ? Number(draft[f.key] || 0) : draft[f.key];
    });
    onChange([...items, item]);
    setDraft(fields.reduce((o, f) => ((o[f.key] = ""), o), {}));
  };

  const remove = (id) => onChange(items.filter((x) => x.id !== id));

  const numField = fields.find((f) => f.type === "num" && f.key !== "precio");
  const priceField = fields.find((f) => f.key === "precio");
  const nameField = fields.find((f) => f.type === "text");

  return (
    <div style={S.wrap}>
      <div>
        {items.map((it) => (
          <div key={it.id} style={S.item}>
            <div style={S.info}>
              <span style={S.name}>
                {numField ? `${it[numField.key]}× ` : ""}
                {nameField ? it[nameField.key] : ""}
              </span>
              {priceField && (
                <span style={S.det}>{`${fmt(it.precio)}/mes`}</span>
              )}
            </div>
            <button
              type="button"
              onClick={() => remove(it.id)}
              title="Eliminar"
              aria-label="Eliminar item"
              style={S.removeBtn}
            >
              ×
            </button>
          </div>
        ))}
      </div>

      <div style={S.rowAdd}>
        {fields.map((f) => (
          <input
            key={f.key}
            type={f.type === "num" ? "number" : "text"}
            placeholder={f.placeholder}
            value={draft[f.key]}
            onChange={(e) => setDraft({ ...draft, [f.key]: e.target.value })}
            aria-label={f.placeholder || f.key}
            style={
              f.key === "cantidad"
                ? { ...S.input, ...S.qty }
                : f.key === "precio"
                ? { ...S.input, ...S.price }
                : S.input
            }
          />
        ))}
        <button type="button" onClick={add} aria-label="Agregar item" style={S.addBtn}>
          +
        </button>
      </div>
    </div>
  );
}

// Estilos inline — son del chrome del formulario, no del documento imprimible.
const S = {
  wrap: { marginBottom: 8 },
  item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 8px",
    background: "#f6f7f9",
    borderRadius: 6,
    marginBottom: 4,
    fontSize: 12,
  },
  info: { display: "flex", flexDirection: "column", gap: 2 },
  name: { color: "#0B0B0F" },
  det: { color: "#6B7280", fontSize: 11 },
  removeBtn: {
    background: "transparent",
    border: 0,
    color: "#c33",
    cursor: "pointer",
    fontSize: 14,
    padding: "0 4px",
  },
  rowAdd: { display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" },
  input: {
    flex: 1,
    minWidth: 0,
    border: "1px solid #ddd",
    borderRadius: 8,
    padding: "7px 9px",
    font: "inherit",
    fontSize: 12,
  },
  qty: { flex: "0 0 56px" },
  price: { flex: "0 0 84px" },
  addBtn: {
    background: "#0080FF",
    color: "#fff",
    border: 0,
    borderRadius: 8,
    padding: "0 12px",
    cursor: "pointer",
    fontSize: 12,
  },
};
